import { useNavigate } from 'react-router-dom';
import AppLayout from '@/pages/app/components/AppLayout';

const sections = [
  {
    title: '제1조 (목적)',
    content: `이 약관은 코리아케어러스(이하 "회사")가 제공하는 가족간병 등록 서비스, 간병비 보험 청구 지원 서비스 및 관련 제반 서비스(이하 "서비스")의 이용에 관한 조건 및 절차, 회사와 이용자 간의 권리·의무 및 책임 사항을 규정함을 목적으로 합니다.`,
  },
  {
    title: '제2조 (용어의 정의)',
    content: `이 약관에서 사용하는 용어의 정의는 다음과 같습니다.

1. "서비스"란 회사가 제공하는 가족간병 등록, 간병인 매칭, 간병보험 청구 지원 등 일체의 서비스를 말합니다.
2. "이용자"란 이 약관에 따라 회사가 제공하는 서비스를 이용하는 개인 또는 법인을 말합니다.
3. "간병 의뢰인"이란 가족 또는 본인의 간병 서비스를 신청한 이용자를 말합니다.
4. "간병인"이란 회사에 등록하여 간병 서비스를 제공하는 자를 말합니다.
5. "간병일지"란 간병인이 간병 서비스 제공 내역을 기록한 문서로, 보험 청구 시 필요 서류로 활용됩니다.`,
  },
  {
    title: '제3조 (약관의 명시와 개정)',
    content: `① 회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.

② 회사는 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.

③ 회사가 약관을 개정할 경우에는 적용 일자 및 개정 사유를 명시하여 현행 약관과 함께 서비스 초기 화면에 그 적용 일자 7일 전부터 적용 일자 전날까지 공지합니다. 다만, 이용자에게 불리하거나 중요한 내용의 변경은 최소 30일 이상의 사전 유예기간을 두고 공지합니다.

④ 이용자가 개정 약관에 동의하지 않는 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다. 개정 약관의 적용 일자 이후에도 서비스를 계속 이용하는 경우에는 개정 약관에 동의한 것으로 봅니다.`,
  },
  {
    title: '제4조 (서비스의 내용)',
    content: `① 회사가 제공하는 서비스의 내용은 다음과 같습니다.

1. 가족간병 등록 서비스: 간병이 필요한 환자 정보를 등록하고, 적합한 간병인을 매칭해 드리는 서비스
2. 간병인 등록 서비스: 간병 서비스를 제공하고자 하는 개인이 회사에 등록하는 서비스
3. 간병비 보험 청구 지원 서비스: 간병보험 청구에 필요한 서류 수집 및 제출을 지원하는 서비스
4. 고객 상담 서비스: 전화, 카카오톡 채널 등을 통한 상담 서비스

② 회사는 서비스의 내용을 변경할 수 있으며, 이 경우 변경된 서비스의 내용 및 제공 일자를 명시하여 사전에 공지합니다.`,
  },
  {
    title: '제5조 (서비스 이용 신청)',
    content: `① 이용자는 회사가 정한 절차에 따라 서비스 이용을 신청합니다.

② 서비스 이용 신청 시 이용자는 진실되고 정확한 정보를 제공하여야 합니다. 허위 정보 제공으로 발생하는 불이익에 대해 회사는 책임을 지지 않습니다.

③ 회사는 다음 각 호에 해당하는 이용 신청에 대해서는 승낙을 거부하거나 사후에 취소할 수 있습니다.
1. 실명이 아니거나 타인의 명의를 이용한 경우
2. 허위 정보를 기재하거나 회사가 제시하는 내용을 기재하지 않은 경우
3. 이용자의 귀책 사유로 인하여 승인이 불가능한 경우
4. 기타 이 약관에 위배되거나 위법·부당한 이용 신청인 경우`,
  },
  {
    title: '제6조 (간병비 및 보험 청구)',
    content: `① 간병비는 간병인과 환자가 직접 협의하여 결정하며, 이체 방식으로 지급하여야 합니다. 현금 직접 지급은 보험 청구 서류로 인정되지 않을 수 있습니다.

② 보험 청구를 위한 서류는 퇴원 시 카카오톡을 통해 코리아케어러스에 제출하여야 합니다. 필요 서류는 다음과 같습니다.
1. 입·퇴원 확인서
2. 간병일지 (당사 양식)
3. 간병비 이체 영수증
4. 간병인 신분증 앞면

③ 보험사에 제출되는 서류는 이용자가 직접 준비하여야 하며, 회사는 당사 발행 서류 3장을 별도로 제공합니다.

④ 회사는 간병인과 환자 간의 거래를 중개하는 플랫폼으로서, 간병비 지급 또는 보험금 지급을 보장하지 않습니다. 보험금 지급 여부 및 금액은 각 보험사의 약관에 따릅니다.

⑤ 간병인은 간병으로 발생한 수익에 대한 소득세 및 세무 신고 의무가 있으며, 이에 대한 책임은 간병인 본인에게 있습니다. 회사는 간병인의 소득신고를 대행하거나 보장하지 않습니다.`,
  },
  {
    title: '제7조 (이용자의 의무)',
    content: `① 이용자는 다음 행위를 하여서는 안 됩니다.

1. 신청 또는 변경 시 허위 내용의 등록
2. 타인의 정보 도용
3. 회사가 게시한 정보의 변경
4. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 송신 또는 게시
5. 회사와 기타 제3자의 저작권 등 지식재산권에 대한 침해
6. 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
7. 외설 또는 폭력적인 내용의 정보, 글, 그림, 음성 등을 서비스에 공개 또는 게시하는 행위
8. 기타 불법적이거나 부당한 행위

② 이용자는 관련 법령, 이 약관의 규정, 이용 안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.`,
  },
  {
    title: '제8조 (서비스의 중단)',
    content: `① 회사는 컴퓨터 등 정보통신설비의 보수 점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.

② 회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.

③ 사업 종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는 제8조에 정한 방법으로 이용자에게 통지하고 당초 회사에서 제시한 조건에 따라 소비자에게 보상합니다.`,
  },
  {
    title: '제9조 (면책 조항)',
    content: `① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.

② 회사는 이용자의 귀책 사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.

③ 회사는 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.

④ 회사는 이용자가 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.

⑤ 보험금 지급에 관한 결정 및 책임은 전적으로 해당 보험사에 있으며, 회사는 이에 관여하지 않습니다.`,
  },
  {
    title: '제10조 (분쟁 해결)',
    content: `① 회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상 처리하기 위하여 피해보상처리 기구를 설치·운영합니다.

② 회사는 이용자로부터 제출되는 불만 사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리 일정을 즉시 통보해 드립니다.

③ 회사와 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제 신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁 조정 기관의 조정에 따를 수 있습니다.`,
  },
  {
    title: '제11조 (재판권 및 준거법)',
    content: `① 회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속 관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할 법원에 제기합니다.

② 회사와 이용자 간에 제기된 전자상거래 소송에는 한국법을 적용합니다.

③ 부칙: 이 약관은 2026년 1월 1일부터 시행합니다.`,
  },
];

export default function AppTermsPage() {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <div className="min-h-screen pb-24 bg-[#F8F9FA]">
        {/* 헤더 */}
        <div className="px-5 pt-6 pb-4 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-xl border border-gray-200 bg-white flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors"
          >
            <i className="ri-arrow-left-line text-gray-600" />
          </button>
          <div>
            <h1 className="text-lg font-extrabold text-gray-900">이용약관</h1>
            <p className="text-xs text-gray-400">시행일: 2026년 1월 1일</p>
          </div>
        </div>

        {/* 안내 */}
        <div className="px-5 mb-5">
          <div className="bg-[#E8F5E9] rounded-2xl p-4">
            <p className="text-sm text-[#2E7D6B] font-medium">
              코리아케어러스 서비스를 이용하시기 전에 아래 이용약관을 주의 깊게 읽어보시기 바랍니다.
              서비스 이용 시 본 약관에 동의하는 것으로 간주됩니다.
            </p>
          </div>
        </div>

        {/* 본문 */}
        <div className="px-5">
          <div className="space-y-5">
            {sections.map((section, index) => (
              <div key={index} className="bg-white rounded-2xl p-5 border border-gray-100">
                <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-start gap-2.5">
                  <span className="w-5 h-5 rounded-full bg-[#2E7D6B] flex items-center justify-center text-[10px] font-bold text-white flex-shrink-0 mt-0.5">
                    {index + 1}
                  </span>
                  {section.title}
                </h2>
                <div className="pl-7.5">
                  <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{section.content}</p>
                </div>
              </div>
            ))}
          </div>

          {/* 문의 */}
          <div className="mt-6 mb-4 p-5 rounded-2xl bg-white border border-gray-100">
            <p className="text-sm font-bold text-gray-900 mb-2">약관 관련 문의</p>
            <p className="text-xs text-gray-500 leading-relaxed">
              이용약관에 관한 문의사항은 아래로 연락해 주세요.
            </p>
            <div className="mt-3 space-y-1 text-xs text-gray-500">
              <p>전화: 1566-8654</p>
              <p>이메일: support@koreacarers.com</p>
              <p>FAX: 070-7862-8654</p>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}